import { InlineText3 } from '@cian/ui-kit/typography';

import * as React from 'react';
// tslint:disable-next-line: match-default-export-name
import cn from 'classnames';

import * as styles from './styles.css';

interface IFromCommercialOwnerShield {
  className?: string;
}

export const FromCommercialOwnerShield: React.FC<IFromCommercialOwnerShield> = ({ className }) => {
  return <div className={cn(styles['root'], className)}>
    <InlineText3 color="white_100">От собственника</InlineText3>
  </div>;
};

FromCommercialOwnerShield.displayName = 'FromCommercialOwnerShield';
